<template>
  <SectionContentBadgeImageTextSplit v-bind="props" />
</template>

<script setup>
const props = defineProps({
  badgeText: {
    type: String,
    default: ''
  },
  title: {
    type: String,
    default: 'Walking'
  },
  content: {
    type: String,
    default: `<p>Walking is free. And, walking is accessible to everyone.</p>
<p>But even better, walking is one of the best ways to improve the health of your heart.</p>
<p>Just 30 minutes of brisk walking each day can:</p>
<ul>
  <li>Help strengthen your heart</li>
  <li>Lower blood pressure</li>
  <li>Support reduction of LDL (bad) cholesterol</li>
  <li>Aid in weight management</li>
  <li>Reduce your risk of heart disease by up to 30% <sup>14</sup></li>
</ul>
<p>So, grab your pup, a friend, your spouse, or go it alone, but get out each day and walk.</p>
<p>You'll not only improve the health of your heart, you'll also reduce stress levels, improve mental health, decrease your waistline, strengthen your bones, improve muscle mass, and so much more!</p>`
  },
  imageSrc: {
    type: String,
    default: ''
  },
  imageAlt: {
    type: String,
    default: 'Man walking outdoors with headphones'
  },
  imagePosition: {
    type: String,
    default: 'right'
  },
  contentGap: {
    type: String,
    default: 'medium'
  },
  showDivider: {
    type: Boolean,
    default: false
  },
  paddingTop: {
    type: String,
    default: 'reduced'
  },
  paddingBottom: {
    type: String,
    default: 'default'
  }
})

defineBuilderComponent({
  friendlyName: 'Content - Split Walking',
  inputs: [
    {
      name: 'badgeText',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'title',
      type: 'richText',
      defaultValue: 'Walking'
    },
    {
      name: 'content',
      type: 'richText',
      defaultValue: `<p>Walking is free. And, walking is accessible to everyone.</p>
<p>But even better, walking is one of the best ways to improve the health of your heart.</p>
<p>Just 30 minutes of brisk walking each day can:</p>
<ul>
  <li>Help strengthen your heart</li>
  <li>Lower blood pressure</li>
  <li>Support reduction of LDL (bad) cholesterol</li>
  <li>Aid in weight management</li>
  <li>Reduce your risk of heart disease by up to 30% <sup>14</sup></li>
</ul>
<p>So, grab your pup, a friend, your spouse, or go it alone, but get out each day and walk.</p>
<p>You'll not only improve the health of your heart, you'll also reduce stress levels, improve mental health, decrease your waistline, strengthen your bones, improve muscle mass, and so much more!</p>`
    },
    {
      name: 'imageSrc',
      type: 'file',
      allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp'],
      defaultValue: ''
    },
    {
      name: 'imageAlt',
      type: 'text',
      defaultValue: 'Man walking outdoors with headphones'
    },
    {
      name: 'imagePosition',
      type: 'text',
      enum: ['left', 'right'],
      defaultValue: 'right'
    },
    {
      name: 'contentGap',
      type: 'text',
      enum: ['large', 'medium'],
      defaultValue: 'medium'
    },
    {
      name: 'showDivider',
      type: 'boolean',
      defaultValue: false
    },
    {
      name: 'paddingTop',
      type: 'text',
      enum: ['default', 'reduced'],
      defaultValue: 'reduced'
    },
    {
      name: 'paddingBottom',
      type: 'text',
      enum: ['default', 'reduced'],
      defaultValue: 'default'
    }
  ]
})
</script>
